import { FC, useRef } from 'react';

import gameManager from "api/gameManager/GameManager";

import { useClickOutside } from 'shared/hooks/useClickOutside';
import { useDragScroll } from 'shared/hooks/useDragScroll';

import Icon from "../../../../shared/components/Icon";

import { SWrapper, STitle, SOptions, SOption } from './style';
import { TAutoOptionProps } from './types';

const AutoOption: FC<TAutoOptionProps> = ({
  optionTitle,
  autoOptions,
  handleOption,
  onClickOutside,
}) => {
  const elRef = useRef<HTMLDivElement | null>(null);
  const elOptionsRef = useRef<HTMLDivElement | null>(null);

  useClickOutside(elRef, onClickOutside);
  useDragScroll(elOptionsRef);

  return (
    <SWrapper ref={elRef}>
      <STitle>{optionTitle}</STitle>
      <SOptions className="no-scrollbars" ref={elOptionsRef}>
        {autoOptions.map(({ title, value }) => (
          <SOption key={value} onClick={() => handleOption(value)}>

            {title == "-1" ? <Icon name="ic_infinitysign" /> : title}
            {/*{title}*/}
          </SOption>
        ))}
      </SOptions>
    </SWrapper>
  );
};

export default AutoOption;
